import { configureStore } from '@reduxjs/toolkit';
import pageSliceReducer from '../redux/settings/page-settings-slice';
import { apiSlice } from '../redux/api-slice';
import filterStateReducer from '../redux/filter/filter-slice';
import searchDataReducer from '../redux/search-data/search-data-slice';

export const store = configureStore({
    reducer: {
        filterState: filterStateReducer,
        pageSettings: pageSliceReducer,
        searchData: searchDataReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(apiSlice.middleware)

});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
